import React from "react";
import { Helmet } from "react-helmet-async";
import blogPosts from "../data/blogPostsData";
import BlogCards from "./BlogCards";
import "../styles/Blog.css";

function BlogPage() {
  return (
    <>
      <Helmet>
        <html lang="es-MX" />
        <title>Blog de cursos y certificaciones | Fundacion Nican</title>
        <meta
          name="description"
          content="Articulos sobre cursos profesionales, certificaciones SEP-CONOCER, enfermeria, quiropractica, masoterapia y terapias fisicas en Mexico."
        />
        <link rel="canonical" href="https://fundacionnican.com/blog" />
      </Helmet>

      <main className="blog-page">
        <section className="container blog-header">
          <h1>Blog de cursos y certificaciones profesionales</h1>
          <p>
            Guias para personas de Ixtapaluca, Chalco, Valle de Chalco y Estado
            de Mexico que quieren crecer profesionalmente en salud, bienestar y
            certificaciones laborales.
          </p>
        </section>

        <section className="container blog-grid-section">
          <BlogCards posts={blogPosts} />
        </section>
      </main>
    </>
  );
}

export default BlogPage;
